// fetchMediaMenifest.js
import 'isomorphic-fetch';
import parseM3u8 from './parseM3u8.js';
import parseMpd from './parseMpd.js';
import { getAssetManifest, MediaPreset } from '../resource/getMediaAsset.js';

const parsers = {
  m3u8: parseM3u8,
  mpd: parseMpd,
};

/**
 * Fetch the media menifest
 * @param {String} { id } - the message id
 * @param {String} { assetId } - the message asset id
 * @param {String} { [ type ] } - the media type
 */
const fetchMediaMenifest = async ({ id, assetId, type = 'm3u8' }) => {
  const url = getAssetManifest({
    id,
    assetId,
    format: type,
    preset: MediaPreset.SD,
  });
  const response = await fetch(url.href);
  if (!response.ok) {
    throw new Error(`fetch_menifest_error [${response.status}]`);
  }

  const text = await response.text();
  const parsedData = await parsers[type]({ data: text, manifestUri: url.href });
  return { [type]: parsedData };
};

export default fetchMediaMenifest;
